import React from "react";
import { NewTab, PageTabAdv } from "../../../components";
import GetAccountDetails from "./AccountDetail/GetAccountDetails";
import AllAccounts from "./AccountDetail/AllAccounts";
import { useModuleAccess } from "../../../hooks";
import BdmLeadProfile from "./AccountDetail/BdmLeadProfile";

const AccountDetails = () => {
  const LeadsMenus = [
    {
      title: "Lead Profile",
      page: <BdmLeadProfile />,
      type: "main",
      id: "accountdetails_bdmleadprofile",
    },
    {
      title: "Get Account Details",
      page: <GetAccountDetails />,
      type: "main",
      id: "accountdetails_getaccountdetails",
    },
    {
      title: "All Accounts",
      page: <AllAccounts />,
      type: "main",
      id: "accountdetails_allaccounts",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: LeadsMenus,
    parentId: "accountdetails",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="account-details"
      />
    </div>
  );
};

export default AccountDetails;
